
export const vehicleColors = [
    { value: '', label: '---', hex: 'transparent', textColor: 'transparent' },
    { value: 'noir', label: 'Noir', hex: '#000000', textColor: '#FFFFFF' },
    { value: 'blanc', label: 'Blanc', hex: '#FFFFFF', textColor: '#333333' },
    { value: 'gris', label: 'Gris', hex: '#808080', textColor: '#FFFFFF' },
    { value: 'argent', label: 'Argent', hex: '#C0C0C0', textColor: '#333333' },
    { value: 'bleu', label: 'Bleu', hex: '#0000FF', textColor: '#FFFFFF' },
    { value: 'rouge', label: 'Rouge', hex: '#FF0000', textColor: '#FFFFFF' },
    { value: 'vert', label: 'Vert', hex: '#00FF00', textColor: '#333333' },
    { value: 'jaune', label: 'Jaune', hex: '#FFFF00', textColor: '#333333' },
    { value: 'orange', label: 'Orange', hex: '#FFA500', textColor: '#333333' },
    { value: 'marron', label: 'Marron', hex: '#A52A2A', textColor: '#FFFFFF' },
    { value: 'beige', label: 'Beige', hex: '#F5F5DC', textColor: '#333333' },
    { value: 'violet', label: 'Violet', hex: '#800080', textColor: '#FFFFFF' },
    { value: 'rose', label: 'Rose', hex: '#FFC0CB', textColor: '#333333' },
    { value: 'or', label: 'Or', hex: '#FFD700', textColor: '#333333' },
    { value: 'autre', label: 'Autre couleur', hex: '#CCCCCC', textColor: '#333333' }
  ];